/* ON Móveis · cotações de frete (v238)
   Conta cada cotação de frete que o cliente faz no site (na ficha do produto e na caixa) e manda para o Painel ON:
   CEP só com os 5 primeiros dígitos, estado, produtos, valor, opções de frete e prazo, o canal de origem e uma
   sessão aleatória deste navegador. A sessão também vai como atributo oculto do carrinho (_painel_s), para o painel
   ligar a cotação ao pedido. Nada de nome, e-mail, endereço ou CEP completo. Não muda nada na tela.
   Carrega no <head>, antes do onm-frete.js, para ver a cotação que a ficha faz assim que abre. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var DESTINO = 'https://klseoibxewffzmrgdnaa.supabase.co/functions/v1/cotacoes';
  var orig = window.fetch;
  if (typeof orig !== 'function') return;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }
  /* prévia de tema ou teste: grava marcado como teste, fora das contas do painel */
  var teste = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') || ss('onm_cot_teste') === '1';
  if (teste) ss('onm_cot_teste', '1');

  var memo = null;
  function sessao() {
    if (memo) return memo;
    var s = ss('onm_s');
    if (!s || !/^[a-z0-9]{12,24}$/.test(s)) {
      var a = new Uint8Array(10);
      try { crypto.getRandomValues(a); } catch (e) { for (var i = 0; i < a.length; i++) a[i] = Math.floor(Math.random() * 256); }
      s = Array.prototype.map.call(a, function (b) { return ('0' + b.toString(36)).slice(-2); }).join('').slice(0, 16);
      ss('onm_s', s);
    }
    memo = s;
    return s;
  }
  function canal() {
    try { var o = JSON.parse(localStorage.getItem('onm_origem') || 'null'); return o && o.k ? String(o.k) : ''; } catch (e) { return ''; }
  }
  var feitos = {};
  function enviar(p) {
    if (!p.cep && !p.uf) return;
    var chave = [p.t, p.cep, (p.it || []).map(function (i) { return i.v || i.s || i.h; }).join(','), (p.op || []).map(function (o) { return o.p; }).join(',')].join('|');
    if (feitos[chave]) return;
    feitos[chave] = 1;
    p.s = sessao(); p.c = canal(); p.d = /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'm' : 'd'; p.pg = location.pathname.slice(0, 120);
    if (teste) p.teste = true;
    var corpo = JSON.stringify(p);
    try { if (navigator.sendBeacon && navigator.sendBeacon(DESTINO, new Blob([corpo], { type: 'text/plain' }))) return; } catch (e) {}
    try { orig.call(window, DESTINO, { method: 'POST', body: corpo, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
  }
  function opcoes(lista) {
    return (lista || []).filter(function (o) { return o && isFinite(o.p); }).sort(function (a, b) { return a.p - b.p; }).slice(0, 8);
  }
  function cep5(c) { c = String(c || '').replace(/\D/g, ''); return c.length >= 5 ? c.slice(0, 5) : ''; }
  function param(url, nome) {
    var cod = nome.replace(/\[/g, '%5B').replace(/\]/g, '%5D'), m = null;
    [cod, nome].some(function (n) { m = new RegExp('[?&]' + n.replace(/[[\]]/g, '\\$&') + '=([^&#]*)', 'i').exec(url); return !!m; });
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }

  /* a sessão vai no carrinho uma vez: o pedido chega com ela */
  function marcarCarrinho() {
    if (ss('onm_s_cart') === sessao()) return;
    ss('onm_s_cart', sessao());
    try {
      orig.call(window, '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _painel_s: sessao() } }) }).catch(function () { ss('onm_s_cart', ''); });
    } catch (e) {}
  }

  /* caixa: /cart/async_shipping_rates.json devolve as transportadoras da Intelipost para o CEP */
  function taxasCaixa(url, j) {
    var rates = j && j.shipping_rates;
    if (!Array.isArray(rates)) return;
    var cep = cep5(param(url, 'shipping_address[zip]')), uf = String(param(url, 'shipping_address[province]') || '').toUpperCase().slice(0, 2);
    orig.call(window, '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var itens = (c && c.items || []).slice(0, 20).map(function (i) {
        return { h: i.handle, v: String(i.variant_id || ''), s: i.sku || undefined, q: i.quantity, p: i.quantity ? Math.round(i.final_line_price / i.quantity) / 100 : undefined };
      });
      enviar({ t: 'carrinho', cep: cep, uf: uf, it: itens, vi: c && isFinite(c.items_subtotal_price) ? c.items_subtotal_price / 100 : undefined,
        op: opcoes(rates.map(function (t) {
          var d = t.delivery_range && t.delivery_range.length ? t.delivery_range : (t.delivery_days || []);
          return { n: String(t.presentment_name || t.name || '').slice(0, 80), p: parseFloat(t.price || '0'), d1: d.length ? +d[0] : undefined, d2: d.length ? +d[d.length - 1] : undefined };
        })) });
      if (c && c.item_count > 0) marcarCarrinho();
    }).catch(function () {});
  }

  /* ficha: o carrinho à parte da Storefront API traz as opções da Intelipost para a variante e o CEP */
  var pendentes = {};
  function precoVariante(v) {
    try { var cfg = JSON.parse((document.getElementById('pfCfg') || {}).textContent || '{}'); var p = cfg.precos && cfg.precos[v]; return p != null ? p / 100 : undefined; } catch (e) { return undefined; }
  }
  function storefront(pedido, j) {
    var req; try { req = JSON.parse(pedido); } catch (e) { return; }
    var vars = req && req.variables || {}, d = j && j.data || {};
    var cart = (d.cartCreate && d.cartCreate.cart) || d.cart;
    if (!cart) return;
    var info = pendentes[cart.id];
    if (!info && vars.i) {
      var linha = (vars.i.lines || [])[0] || {}, end = (((vars.i.buyerIdentity || {}).deliveryAddressPreferences || [])[0] || {}).deliveryAddress || {};
      var v = String(linha.merchandiseId || '').split('/').pop();
      var h = (/\/products\/([^/?#]+)/.exec(location.pathname) || [])[1];
      info = { v: v, h: h, q: linha.quantity || 1, cep: cep5(end.zip), uf: String(end.province || '').toUpperCase().slice(0, 2) };
      pendentes[cart.id] = info;
    }
    if (!info) return;
    var g = cart.deliveryGroups && cart.deliveryGroups.nodes && cart.deliveryGroups.nodes[0], ops = g ? g.deliveryOptions || [] : [];
    if (!ops.length) return;
    delete pendentes[cart.id];
    var preco = precoVariante(info.v);
    enviar({ t: 'produto', cep: info.cep, uf: info.uf, it: [{ h: info.h, v: info.v, q: info.q, p: preco }], vi: preco != null ? preco * info.q : undefined,
      op: opcoes(ops.map(function (o) { return { n: String(o.title || '').slice(0, 80), p: parseFloat(o.estimatedCost && o.estimatedCost.amount) }; })) });
  }

  window.fetch = function (input) {
    var args = arguments, url = typeof input === 'string' ? input : (input && input.url) || '';
    var init = args[1], corpo = init && typeof init.body === 'string' ? init.body : null;
    var pr = orig.apply(window, args);
    try {
      if (/\/cart\/async_shipping_rates\.json/.test(url)) {
        pr.then(function (r) { if (r.status === 200) r.clone().json().then(function (j) { taxasCaixa(url, j); }).catch(function () {}); }).catch(function () {});
      } else if (/\/api\/[^/]+\/graphql\.json/.test(url) && corpo && corpo.indexOf('deliveryGroups') >= 0) {
        pr.then(function (r) { r.clone().json().then(function (j) { storefront(corpo, j); }).catch(function () {}); }).catch(function () {});
      }
    } catch (e) {}
    return pr;
  };
})();
